import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { DEFAULT_TIME } from "../constant/ReportConstants";
import useLocationHelpers from "../hooks/useLocationHelpers";
import { getReportDefaultDateFilter } from "../helpers/reportSettings";

export const ReportDateFilterContext = createContext();

export const ReportDateFilterProvider = ({ children }) => {
  const { currentLocation, isUserLoaded } = useLocationHelpers();

  const [dateFilter, setDateFilter] = useState(DEFAULT_TIME);
  const [dateRange, setDateRange] = useState(null);
  const [departmentTypes, setDepartmentTypes] = useState([]);
  const [selectedLocationId, setSelectedLocationId] = useState(null);
  const [initialized, setInitialized] = useState(false);
  const didInit = useRef(false);

  useEffect(() => {
    if (!isUserLoaded || didInit.current) return;
    didInit.current = true;
    const { filter, range } = getReportDefaultDateFilter(currentLocation?.settings);
    setDateFilter(filter);
    setDateRange(range);
    setInitialized(true);
  }, [isUserLoaded, currentLocation]);

  return (
    <ReportDateFilterContext.Provider
      value={{
        dateFilter,
        setDateFilter,
        dateRange,
        setDateRange,
        departmentTypes,
        setDepartmentTypes,
        selectedLocationId,
        setSelectedLocationId,
        isReady: initialized,
      }}
    >
      {children}
    </ReportDateFilterContext.Provider>
  );
};

export const useReportDateFilter = () => {
  const context = useContext(ReportDateFilterContext);
  if (!context) {
    throw new Error("useReportDateFilter must be used within a ReportDateFilterProvider");
  }
  return context;
};
